module.exports = __webpack_public_path__ + "static/media/1POLICY1.7b72e924.jpg";